//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TaggedObject.js";
let d=[[[0,"AreaFillAngle",1,0],[0,"AreaFillMaterial",1,0],[0,"AreaFillScale",1,0],[0,"AutoTextIsland",1,0],[0,"Color",1,0],[0,"FindApparentIntersections",1,0],[0,"HatchAngle",1,0],[0,"HatchDistance",1,0],[0,"HatchFile",1,0],[0,"HatchMaterial",1,0],[0,"IslandMargin",1,0],[0,"LineWidth",1,0],[0,"Tolerance",1,0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Annotations.HatchStyleBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.HatchStyleBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;